import React, { useContext, useEffect, useState } from "react"
import { Link } from "gatsby"
import "../styles/template.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTwitter, faInstagram, faFacebookF } from "@fortawesome/free-brands-svg-icons"
import { faAdjust } from "@fortawesome/free-solid-svg-icons"
import { templateContent } from "../content/template"
import { SettingsContext, actions } from "../contexts/settings"
import { Helmet } from "react-helmet"
 
const navItems = [
    { name: "homepage", url: "/" },
    { name: "about", url: "/ueber" },
    { name: "schedule", url: "/programm" },
    { name: "projects", url: "/projekte" },
    { name: "digital", url: "/digitales" },
    { name: "accessibility", url: "/barrierefreiheit" },
    { name: "blog", url: "/blog" },
    { name: "tickets", url: "https://www.eventbrite.de/o/nocturnal-unrest-33095283589", target: "_blank" }
]
const footerItems = [
    { name: "cooperations", url: "/kooperationen" },
    { name: "help", url: "/hilfe" },
    { name: "team", url: "/team" }
]




const Template = ({ children, currentPage , omitLogo=false}) => {
    const [settings, dispatchSettingsAction] = useContext(SettingsContext)
    const content = templateContent[settings.language]
    const [isInitialLoad, setIsInitialLoad] = useState(true)

    useEffect(
        () => {
            if (!isInitialLoad) {
                console.log(settings)
                localStorage.setItem("isHighContrast", settings.isHighContrast)
                localStorage.setItem("isBigFont", settings.isBigFont)
                localStorage.setItem("language", settings.language)
                return
            }
            const storedIsHighContrast = localStorage.getItem("isHighContrast")
            if (storedIsHighContrast !== null) {
                dispatchSettingsAction(actions.setIsHighContrast(JSON.parse(storedIsHighContrast)))
            }
            const storedIsBigFont = localStorage.getItem("isBigFont")
            if (storedIsBigFont !== null) {
                dispatchSettingsAction(actions.setIsBigFont(JSON.parse(storedIsBigFont)))
            }
            const storedLanguage = localStorage.getItem("language")
            if (storedLanguage !== null) {
                dispatchSettingsAction(actions.changeLanguage(storedLanguage))
            }
            setIsInitialLoad(false)
        },
        [dispatchSettingsAction, isInitialLoad, settings]
    )

    return (
        <div className="page-container">
            <Helmet htmlAttributes={{ lang: 'de' }} />
            <div className={`page ${settings.isHighContrast ? "high-contrast" : "normal-contrast"} ${settings.isBigFont ? "big-font" : "normal-font"}`}>
                <div className="banner-side" >

                </div>
                <div className="content">
                    <header>
                        <div>
                            <div className="logo-buttons">
                                <Link className="logo-link" to="/" aria-label="nOu-Logo">
                                    <div className="logo-container" style={omitLogo ? {display: "none"} : null}/>
                                </Link>
                                <div className="change-buttons">
                                    <div className="change-font-size-container">
                                        <button onClick={() => dispatchSettingsAction(actions.toggleIsBigFont())}>
                                            <img className="change-font-size-button" src="/images/icon-fontsize.svg" alt={content.buttonChangeFontsize} />
                                        </button>
                                    </div>
                                    <div className="high-contrast-button-container">
                                        <button className="contrast-icon" onClick={() => dispatchSettingsAction(actions.toggleIsHighContrast())} aria-label={content.buttonChangeContrast}>
                                            <FontAwesomeIcon icon={faAdjust} />
                                        </button>
                                    </div>
                                </div>
                                <div className="language-buttons">
                                    <button className="button" onClick={() => dispatchSettingsAction(actions.changeLanguage("german"))} aria-label={content.buttonGerman}>
                                        <span className="black-button">DEUTSCH</span>
                                        <div className="mint-line"></div>
                                    </button>
                                    <button className="button" onClick={() => dispatchSettingsAction(actions.changeLanguage("english"))}  aria-label={content.buttonEnglish}>
                                        <span className="black-button">ENGLISH</span>
                                        <div className="mint-line"></div>
                                    </button>

                                </div>
                            </div>
                            <div>
                                <div className="white-line"></div>
                                <nav>
                                    <div className="navbar">
                                        {navItems.map(({ name, url, target }) => (<Link target={ target } to={url} className={`buttons-navbar ${currentPage === name ? "current" : ""}`}>{content[name]}</Link>))}

                                    </div>
                                </nav>
                                <div className="white-line"></div>
                                <div className="transparent-line"></div>
                                <div className="white-line"></div>
                            </div>
                        </div>
                    </header>
                    <main>
                        {children}
                    </main>
                    <footer>
                        <div className="footer">
                            <div className="white-line"></div>
                            <div className="lower-navbar">
                                {footerItems.map(({ name, url }) => (<a href={url} className={`buttons-lower-navbar ${currentPage === name ? "current" : ""}`}>{content[name]}</a>))}
                            </div>
                            <div className="white-line"></div>
                            <div className="icons">
                                <div className="icon">
                                    <a href="https://twitter.com/nocturnalunrest" target="_blank" rel="noopener noreferrer" className="fab" aria-label="Twitter">
                                        <FontAwesomeIcon icon={faTwitter} />
                                    </a>
                                </div>
                                <div className="icon">
                                    <a href="https://www.facebook.com/noufrankfurt/" target="_blank" rel="noopener noreferrer" className="fab" aria-label="Facebook">
                                        <FontAwesomeIcon icon={faFacebookF} />
                                    </a>
                                </div>
                                <div className="icon">
                                    <a href="https://www.instagram.com/nocturnalunrest/" target="_blank" rel="noopener noreferrer" className="fab" aria-label="Instagram">
                                        <FontAwesomeIcon icon={faInstagram} />
                                    </a>
                                </div>
                            </div>


                            <div className="bottom-links">
                                <div className="bottom-links-single">
                                    <a href="/impressum" className="link-footer" aria-label="Impressum">{content.legalNotice}</a>
                                </div>
                                <div className="bottom-links-single">
                                    <a href="https://dlist.server.uni-frankfurt.de/mailman/listinfo/nocturnalunrest" target="_blank" rel="noopener noreferrer" className="link-footer" aria-label="News-Letter">{content.newsLetter}</a>
                                </div>
                            </div>

                            <div className="logos-template">
                                <div className="partner">
                                    <Link className="logo-xbig" to="/kooperationspartner/femphils">
                                        <img className="footer-img" src="/logos/Kooperationspartner/bw/bw_Logo_femphils.png" alt={content.logoFemphils} />
                                    </Link>
                                    <Link className="logo-big" to="/kooperationspartner/ladiez">
                                        <img className="footer-img" src={settings.isHighContrast ? "/logos/Kooperationspartner/bw/inverted/bw_inverted_Logo_Ladiez.png" : "/logos/Kooperationspartner/bw/bw_Logo_Ladiez.png"} alt={content.logoLadiez} />
                                    </Link>
                                    <Link className="logo-small" to="/kooperationspartner/mousonturm">
                                        <img className="footer-img" src={settings.isHighContrast ? "/logos/Kooperationspartner/bw/inverted/bw_inverted_Logo_Mousonturm.png" : "/logos/Kooperationspartner/bw/bw_Logo_Mousonturm.png"} alt={content.logoMousonturm} />
                                    </Link>
                                    <Link className="logo-medium" to="/kooperationspartner/hafen2">
                                        <img className="footer-img" src={settings.isHighContrast ? "/logos/Kooperationspartner/bw/inverted/bw_inverted_Logo_Hafen2.png" : "/logos/Kooperationspartner/bw/bw_Logo_Hafen2.png"} alt={content.logoHafen2} />
                                    </Link>
                                </div>
                                <div className="logo-stabstelle-container">
                                    <p className="sponsor-template">{content.sponsor}</p>
                                    <a href="https://frankfurt.de/service-und-rathaus/verwaltung/aemter-und-institutionen/stabsstelle-inklusion" target="_blank" rel="noopener noreferrer" className="logo-stabstelle">
                                        <img className="footer-img" src={settings.isHighContrast ? "/logos/Kooperationspartner/bw/inverted/bw_inverted_Logo_Stabstelle-Inklusion.png" : "/logos/Kooperationspartner/bw/bw_Logo_Stabstelle-Inklusion.png"} alt={content.logoStabstelle} />
                                    </a>
                                </div>
                            </div>
                        </div>

                    </footer>
                </div>

            </div>
        </div>

    )
}
export default Template